module.exports = __webpack_public_path__ + "static/legacyvolt-400587fbb7eb8c26f051dac7df638580.jpg";